<template>
  <div class>
    <div class="d-flex justify-content-center">
      <div class="col-12">
        <form class="pt-2 pb-4 d-flex flex-wrap justify-content-center" @submit.prevent="register">
          <h3 class="w-75 mt-3 mb-5 d-flex justify-content-center">Create your Account</h3>
          <div class="form-group w-75">
            <label for="First Name">First Name</label>
            <input
              v-validate="'required'"
              id="FirstName"
              v-model="firstName"
              name="First Name"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">{{ OOErrors.first("First Name") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="Last Name">Last Name</label>
            <input
              v-validate="'required'"
              id="LastName"
              v-model="lastName"
              name="Last Name"
              type="text"
              class="form-control"
            />
            <div class="invalid-feedback">{{ OOErrors.first("Last Name") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="email">Email Address</label>
            <input
              id="EmailId"
              v-model="email"
              v-validate="'required|email'"
              type="email"
              name="email"
              class="form-control"
              aria-describedby="emailHelp"
            />
            <div class="invalid-feedback">{{ OOErrors.first("email") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="password">Password</label>
            <input
              id="passwordId"
              v-model="password"
              type="password"
              name="password"
              v-validate="'required'"
              class="form-control"
              ref="password"
            />
            <div class="invalid-feedback">{{ OOErrors.first("password") }}</div>
          </div>
          <div class="form-group w-75">
            <label for="Confirm Password">Confirm Password</label>
            <input
              id="ConfirmPasswordId"
              v-model="confirmPassword"
              type="password"
              name="Confirm Password"
              v-validate="'required|confirmed:password'"
              class="form-control"
            />
            <div class="invalid-feedback">{{ OOErrors.first("Confirm Password") }}</div>
          </div>

          <div class="w-60 mt-4 justify-content-center">
            <p style="font-size:0.6875rem;line-height: 1.4;text-align: center;">
              By continuing you agree to our
              <b>Terms of Use & Privacy Statement</b>
            </p>
          </div>

          <div class="w-75 mt-3">
            <button
              :disabled="loading"
              :style="desktopStyles.btn"
              type="submit"
              class="btn btn-lg btn-sign-in btn-block shadow btn-primary d-flex justify-content-center align-items-center fs-1 fw-600"
            >
              Register
              <span v-show="loading">
                <i class="spin ml-4" />
              </span>
            </button>
          </div>

          <div class="w-75 mt-4 d-flex justify-content-center">
            Already have a profile?&nbsp;
            <a
              href="#"
              :style="desktopStyles.LinkColorTxt"
              @click="$emit('show-login')"
            >Sign in</a>
          </div>
          <div v-show="error" class="w-75 mt-4">
            <div class="alert alert-danger" role="alert">
              <strong>{{ error }}</strong>
            </div>
          </div>
          <div v-if="FacebookLogin || GoogleLogin" class="w-75 my-4 d-flex justify-content-center">
            <strong>or</strong>
          </div>
          <div class="container">
            <div class="row mb-4 justify-content-center">
              <auth-providers-login />
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../../sharedscripts/user/register.js";
import login from "../../sharedscripts/user/login.js";
import AuthProvidersLogin from "./AuthProvidersLogin";
import { mapGetters } from "vuex";
export default {
  components: {
    AuthProvidersLogin
  },
  props: {
    storeid: {
      type: String,
      default: null
    },
    forgift: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      firstName: "",
      lastName: "",
      email: "",
      //mobile: "",
      password: "",
      confirmPassword: "",
      loading: false,
      error: ""
    };
  },
  computed: {
    ...mapGetters(["desktopStyles", "viewConfig"]),
    FacebookLogin() {
      return this.viewConfig.FacebookLogin;
    },
    GoogleLogin() {
      return this.viewConfig.GoogleLogin;
    }
  },
  mounted() {
    this.setStoreLoaded();
  },
  methods: {
    ...shared.methods,
    ...login.methods
  }
};
</script>
